import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

export const ConfirmBackDialog = ({ open, handleClose }) => {
  // hooks
  const router = useRouter();

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <DialogContent
        sx={{
          width: '400px',
        }}
      >
        <Stack>
          <Iconify
            icon="tabler:alert-triangle"
            color="background.primaryRed1"
            width={48}
            sx={{
              mb: '17px',
            }}
          />
          <Typography variant="h4" mb="10px">
            Don&apos;t forget to save your changes
          </Typography>
          <Typography variant="caption" color="content.primaryBlack3">
            Are you sure to move out from job page? Make sure you save all
            changes
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" width="100%" alignItems="center" spacing="12px">
          <Button fullWidth variant="soft" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              router.push(paths.dashboard.jobs.root);
            }}
            autoFocus
          >
            Yes
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

ConfirmBackDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
